
import { computed, defineComponent, onMounted, reactive } from 'vue';
import { useRoute } from 'vue-router';
import type { MenuNode } from '@/common/menu/menuRegistry';
import { useAppRouter } from '@/common/route/useAppRouter';

const globalMenuState = reactive({
    openedLevels: {} as Record<number, string>
});

const __default__ = defineComponent({
    name: 'AppMenuItem',
    props: {
        menuItem: { type: Object as () => MenuNode, required: true },
        level: { type: Number, default: 0 }
    },
    setup(props) {
        const router = useAppRouter();
        const route = useRoute();

        const children = computed(() => props.menuItem.children ?? []);
        const isExpandable = computed(() => children.value.length > 0);
        const hasActiveChild = computed(() => children.value.some(containsActiveRoute));

        const isActive = computed(() => containsActiveRoute(props.menuItem));

        const containsActiveRoute = (node: MenuNode): boolean => {
            if (node.route) {
                const resolvedPath = router.resolve(node.route).path;
                if (route.path === resolvedPath || route.path.startsWith(resolvedPath)) {
                    return true;
                }
            }
            return node.children?.some(child => containsActiveRoute(child)) ?? false;
        };

        const isOpen = computed(() => globalMenuState.openedLevels[props.level] === props.menuItem.key);

        const handleClick = () => {
            if (isExpandable.value) {
                if (isOpen.value) {
                    delete globalMenuState.openedLevels[props.level];
                } else {
                    globalMenuState.openedLevels[props.level] = props.menuItem.key;
                }

                Object.keys(globalMenuState.openedLevels).forEach(level => {
                    if (Number(level) > props.level) {
                        delete globalMenuState.openedLevels[Number(level)];
                    }
                });

                return;
            }

            if (props.menuItem.route) {
                router.push(props.menuItem.route);
            }
        };

        const autoExpand = () => {
            if (hasActiveChild.value) {
                globalMenuState.openedLevels[props.level] = props.menuItem.key;
            }
        };

        onMounted(autoExpand);

        return {
            children,
            isExpandable,
            isActive,
            isOpen,
            hasActiveChild,
            handleClick
        };
    }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "53872610": (_ctx.level)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__